module.exports = "<div v-if=\"config.environment.toLowerCase() != 'production'\" class=\"environment-header\" :style=\"'background-color: '+config.environmentColor\">\r\n  {{ config.environment }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/views/environment-bar.html
// module id = 436
// module chunks = 0